import BilletSend from '../pages/BilletSend';

export const billetSendRoutePage = {
  component: <BilletSend />,
  route: '/envio-de-boleto',
};
